const normalizeCurrency = (value: unknown) => String(value || '').trim().toUpperCase()

export const computeConvertedAmount = (
  amount: unknown,
  exchangeRate: unknown,
  sourceCurrency: unknown,
  targetCurrency: unknown
): number | null => {
  const numericAmount = Number(amount)
  if (!Number.isFinite(numericAmount)) return null
  const normalizedSource = normalizeCurrency(sourceCurrency)
  const normalizedTarget = normalizeCurrency(targetCurrency)
  if (normalizedSource && normalizedTarget && normalizedSource === normalizedTarget) {
    return numericAmount
  }
  const numericRate = Number(exchangeRate)
  if (!Number.isFinite(numericRate) || numericRate <= 0) return null
  return numericAmount * numericRate
}

export const computeUsdEquivalent = (
  amount: unknown,
  exchangeRate: unknown,
  currency: unknown
): number | null => {
  return computeConvertedAmount(amount, exchangeRate, currency, 'USD')
}

export const formatExchangeRateDisplay = (
  currency: unknown,
  exchangeRate: unknown,
  targetCurrency: unknown = 'USD'
): string => {
  const normalizedCurrency = normalizeCurrency(currency) || 'USD'
  const normalizedTargetCurrency = normalizeCurrency(targetCurrency) || 'USD'
  const normalizedRate =
    normalizedCurrency === normalizedTargetCurrency
      ? 1
      : Number.isFinite(Number(exchangeRate)) && Number(exchangeRate) > 0
      ? Number(exchangeRate)
      : null
  if (normalizedRate == null) return '-'
  return `1 ${normalizedCurrency} = ${normalizedRate.toFixed(8).replace(/\.?0+$/, '')} ${normalizedTargetCurrency}`
}
